<!--
 * @Description:
 * @Author: Ingyi
 * @Date: 2021-09-05 21:42:33
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-06 01:07:47
-->
<template>
  <div class="table">
    <a-tabs>
      <a-tab-pane key="1" tab="专利托管">
        <div class="tool-box" style="display: flex">
          <a-form-model-item label="专利有效期" style="display: flex; width: 300px">
            <a-date-picker :locale="locale" v-model="queryForm.patentRegisterTime" valueFormat="YYYY-MM-DD" />
          </a-form-model-item>
          <a-form-model-item label="专利权人" style="display: flex; width: 270px">
            <a-input v-model="queryForm.patentee" style="width: 150px" />
          </a-form-model-item>
          <a-form-model-item label="专利状态" style="display: flex; width: 250px">
            <a-select v-model="queryForm.status" style="width: 150px">
              <a-select-option v-for="item in patentTowingpipes" :key="item.key" :value="item.key">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-button @click="searchList" type="primary">搜索</a-button>
          <a-button @click="exportExcel" type="primary" style="margin-left: 20px">导出</a-button>
        </div>
        <a-table :data-source="data" :scroll="{ x: true }" :columns="columns" rowKey="id"
          style="width: 100%; overflow: hidden">
          <span slot="agencyzId" slot-scope="text">{{ fmtAgency(text) }}</span>
          <span slot="patentType" slot-scope="text">{{ fmtTypes(text) }}</span>
          <span slot="status" slot-scope="text">{{ fmtStatus(text) }}</span>
          <span slot="validityStatus" slot-scope="text, record" v-html="fmtValidity(record)"></span>
          <template slot="operation" slot-scope="text, record">
            <a href="javascript:;" style="margin-right: 8px" @click="() => handleDetail(record)">详情</a>
            <!--<a
               v-if="iszhuang"
              href="javascript:;"
              style="margin-right: 8px"
              @click="() => handestatus(record)"
              >{{record.status==0?'等待审核':record.status==1?'提交专利局':'申请成功'}}</a
            >-->
            <a v-if="userInfo && userInfo.type != '代理机构'" href="javascript:;" style="margin-right: 8px"
              @click="() => handleEdit(record)">修改</a>
            <a v-if="userInfo && userInfo.type == '代理机构'" href="javascript:;" style="margin-right: 8px" @click="() => handlePinggu(record)">专利评估</a>
            <a href="javascript:;" style="margin-right: 8px" @click="() => handlePinggulist(record)">评估记录</a>
            <a v-if="userInfo && userInfo.type == '代理机构'" href="javascript:;" style="margin-right: 8px"
              @click="() => handleEditStatus(record)">修改状态</a>
            <a v-if="userInfo && userInfo.type == '代理机构'" href="javascript:;" style="margin-right: 8px"
              @click="() => handleTuoguan(record)">续期</a>

            <a v-if="userInfo && userInfo.type == '代理机构'" href="javascript:;" style="margin-right: 8px"
              @click="() => handleBinding(record)">绑定负责人</a>
            <a-popconfirm v-if="userInfo && userInfo.type != '代理机构'" okText="确定" cancelText="取消" title="请确认是否删除?"
              @confirm="() => onDelete(record)">
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <a-modal :title="title" :visible="visible" :confirm-loading="confirmLoading" :maskClosable="false" @ok="handleOk"
      okText="确定" cancelText="取消" @cancel="handleCancel" width="800px">
      <a-form-model v-model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-model-item label="专利号">
          <a-input v-if="isEdit" v-model="form.patentNo" :disabled="!isEdit" />
          <span v-else>{{ form.patentNo }}</span>
        </a-form-model-item>
        <a-form-model-item label="专利申请日期">
          <a-date-picker v-if="isEdit" :disabled="!isEdit" :locale="locale" v-model="form.patentRegisterTime"
            valueFormat="YYYY-MM-DD" />
          <span v-else>{{ form.patentRegisterTime }}</span>
        </a-form-model-item>
        <a-form-model-item label="专利名称">
          <a-input v-if="isEdit" v-model="form.patentName" :disabled="!isEdit" />
          <span v-else>{{ form.patentName }}</span>
        </a-form-model-item>
        <a-form-model-item label="专利描述">
          <a-input v-if="isEdit" v-model="form.patentDesc" :disabled="!isEdit" />
          <span v-else>{{ form.patentDesc }}</span>
        </a-form-model-item>
        <a-form-model-item label="标签">
          <template v-for="tag in form.towingpipeLabel">
            <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
              <a-tag :key="tag" :closable="true" @close="() => handleClose(tag)">
                {{ `${tag.slice(0, 20)}...` }}
              </a-tag>
            </a-tooltip>
            <a-tag v-else :key="tag" @close="() => handleClose(tag)">
              {{ tag }}
            </a-tag>
          </template>
          <a-input v-if="inputVisible" ref="input" type="text" size="small" :style="{ width: '78px' }" :value="inputValue"
            @change="handleInputChange" @blur="handleInputConfirm" @keyup.enter="handleInputConfirm" />
          <a-tag style="background: #fff; borderstyle: dashed" @click="showInput">
            <a-icon type="plus" /> 新标签
          </a-tag>
        </a-form-model-item>
        <a-form-model-item label="授权公告日">
          <a-date-picker v-if="isEdit" :disabled="!isEdit" :locale="locale" v-model="form.authAnnouncementTime"
            valueFormat="YYYY-MM-DD" />
          <span v-else>{{ form.authAnnouncementTime }}</span>
        </a-form-model-item>
        <a-form-model-item label="授权公告号">
          <a-input v-if="isEdit" v-model="form.authAnnouncementNo" :disabled="!isEdit" />
          <span v-else>{{ form.authAnnouncementNo }}</span>
        </a-form-model-item>
        <a-form-model-item label="专利有效期">
          <a-date-picker v-if="isEdit" :disabled="!isEdit" :locale="locale" v-model="form.termOfValidity"
            valueFormat="YYYY-MM-DD" />
          <span v-else>{{ form.termOfValidity }}</span>
        </a-form-model-item>
        <a-form-model-item label="年费有效期">
          <a-date-picker v-if="isEdit" :disabled="true" :locale="locale" v-model="form.towingpipeDate"
            valueFormat="YYYY-MM-DD" />
          <span v-else>{{ form.termOfValidity }}</span>
        </a-form-model-item>
        <a-form-model-item label="地址">
          <a-input v-if="isEdit" v-model="form.address" :disabled="!isEdit" />
          <span v-else>{{ form.address }}</span>
        </a-form-model-item>
        <a-form-model-item label="专利类型">
          <a-select v-if="isEdit" v-model="form.patentType" :disabled="!isEdit">
            <a-select-option v-for="item in types" :key="item.key" :value="item.key">
              {{ item.value }}
            </a-select-option>
          </a-select>
          <span v-else>{{ fmtTypes(form.patentType) }}</span>
        </a-form-model-item>
        <a-form-model-item label="专利权人">
          <a-input v-if="isEdit" v-model="form.patentee" :disabled="!isEdit" />
          <span v-else>{{ form.patentee }}</span>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select v-if="isEditStatus" v-model="form.status" :disabled="!isEditStatus">
            <a-select-option v-for="(item, index) in status" :key="item" :value="index">
              {{ item.value }}
            </a-select-option>
          </a-select>
          <span v-else>{{ status && fmtStatus(form.status) }}</span>
        </a-form-model-item>
        <a-form-model-item label="专利权人">
          <a-input v-if="isEdit" v-model="form.patentee" :disabled="!isEdit" />
          <span v-else>{{ form.patentee }}</span>
        </a-form-model-item>
        <a-form-model-item label="专利托管申请人">
          <a-input v-if="isEdit" v-model="form.createUserName" :disabled="true" />
          <span v-else>{{ form.createUserName }}</span>
        </a-form-model-item>
        <a-form-model-item label="专利托管申请时间">
          <a-input v-if="isEdit" v-model="form.createTime" :disabled="true" />
          <span v-else>{{ form.createTime }}</span>
        </a-form-model-item>
        <a-form-model-item label="修改人">
          <a-input v-if="isEdit" v-model="form.updateUserName" :disabled="true" />
          <span v-else>{{ form.updateUserName }}</span>
        </a-form-model-item>
        <a-form-model-item label="修改时间">
          <a-input v-if="isEdit" v-model="form.updateTime" :disabled="true" />
          <span v-else>{{ form.updateTime }}</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal :title="bindingtitle" :visible="bindingvisible" :confirm-loading="confirmLoading" :maskClosable="false"
      @ok="bindingOk" okText="确定" cancelText="取消" @cancel="bindingCancel" width="800px">
      <a-form-model v-model="bindingform" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-model-item label="负责人手机号">
          <a-input v-model="bindingform.userTel" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal :title="tuotitle" :visible="tuoguanvisible" :confirm-loading="confirmLoading" :maskClosable="false"
      @ok="tuoguanOk" okText="确定" cancelText="取消" @cancel="tuoguanCancel" width="800px">
      <a-form-model-item label="专利托管时间">
        <a-date-picker :locale="locale" v-model="tuoguanform.towingpipeDate" valueFormat="YYYY-MM-DD" />
      </a-form-model-item>
    </a-modal>
    <a-modal :title="pinggutitle" :visible="pingguvisible" :confirm-loading="confirmLoading" :maskClosable="false" footer={[]} 
     @cancel="pingguCancel" width="1200px">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane :disabled="true" style="color:black" label="法律价值度" name="first">
          <el-form>
            法律价值度（LVD）=稳定性分值×稳定性权重×（不可规避性分值×不可规避性权重+依赖性分值×依赖性权重+专利侵权可判定性分值×专利侵权可判定性权重+有效期分值×有效期权重+多国申请分值×多国申请权重+专利许可状况分值×专利许可状况权重）
            <el-form-item label="稳定性:">
              <el-radio-group v-model="pingguform.stability">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListStability"  :key="index"
                  :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
               <el-lable>x {{patentEstimateTypeVO.stabilityRule}}</el-lable>
            </el-form-item>
            <el-form-item label="不可规避性:">
              <el-radio-group v-model="pingguform.nonAvoidability">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListNonAvoidability" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.nonAvoidabilityRule}}</el-lable>
            </el-form-item>
            <el-form-item label="依懒性:">
              <el-radio-group v-model="pingguform.indolence">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListIndolence" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.indolenceRule}}</el-lable>
            </el-form-item>
            <el-form-item label="专利侵权可判定性:">
              <el-radio-group v-model="pingguform.determinabilityInfringement">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListDeterminabilityInfringement" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.determinabilityInfringementRule}}</el-lable>
            </el-form-item>
            <el-form-item label="有效期:">
              <el-radio-group v-model="pingguform.periodValidity">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListPeriodValidity" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.periodValidityRule}}</el-lable>
            </el-form-item>
            <el-form-item label="多国申请:">
              <el-radio-group v-model="pingguform.multinationalApplication">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListMultinationalApplication" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.multinationalApplicationRule}}</el-lable>
            </el-form-item>
            <el-form-item label="专利许可状况:">
              <el-radio-group v-model="pingguform.patentLicensing">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListPatentLicensing" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.patentLicensingRule}}</el-lable>
            </el-form-item>
            <el-form-item label="专利法律价值度">
              <el-input v-model="pingguform.lvd" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="nextfirst">下一页</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :disabled="true" style="color:black"  label="技术价值度" name="second">
          <el-form>
            技术价值度（TVD）=（先进性分值×先进性权重+行业发展趋势分值×行业发展趋势权重+适用范围分值×适用范围权重+配套技术依存度分值×配套技术依存度权重+可替代性分值×可替代性权重+成熟度分值×成熟度权重）×10
            <el-form-item label="先进性:">
              <el-radio-group v-model="pingguform.progressiveness">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListProgressiveness"  :key="index"
                  :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
               <el-lable>x {{patentEstimateTypeVO.progressivenessRule}}</el-lable>
            </el-form-item>
            <el-form-item label="行业发展趋势:">
              <el-radio-group v-model="pingguform.industryRends">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListIndustryRends" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.industryRendsRule}}</el-lable>
            </el-form-item>
            <el-form-item label="适用范围:">
              <el-radio-group v-model="pingguform.scopeUse">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListScopeUse" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.scopeUseRule}}</el-lable>
            </el-form-item>
            <el-form-item label="配套技术依存度:">
              <el-radio-group v-model="pingguform.supportingTechnologies">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListSupportingTechnologies" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.supportingTechnologiesRule}}</el-lable>
            </el-form-item>
            <el-form-item label="可替代性:">
              <el-radio-group v-model="pingguform.substitutability">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListSubstitutability" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.substitutabilityRule}}</el-lable>
            </el-form-item>
            <el-form-item label="成熟度:">
              <el-radio-group v-model="pingguform.maturity">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListMaturity" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.maturityRule}}</el-lable>
            </el-form-item>
            <el-form-item label="技术价值度">
              <el-input v-model="pingguform.tvd" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="backfirst">上一页</el-button>
              <el-button type="primary" @click="nextsecond">下一页</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :disabled="true" style="color:black"  label="经济价值度" name="third">
          <el-form>
            经济价值度（EVD）=（市场应用情况分值×市场应用情况权重+市场规模前景分值×市场规模前景权重+市场占有率分值×市场占有率权重+竞争情况分值×竞争情况权重+政策适应性分值×政策适应性权重）×10
            <el-form-item label="市场应用情况:">
              <el-radio-group v-model="pingguform.marketSituation">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListSituation"  :key="index"
                  :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
               <el-lable>x {{patentEstimateTypeVO.marketSituationRule}}</el-lable>
            </el-form-item>
            <el-form-item label="行业发展趋势:">
              <el-radio-group v-model="pingguform.marketProspects">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListMarketProspects" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.marketProspectsRule}}</el-lable>
            </el-form-item>
            <el-form-item label="市场占有率:">
              <el-radio-group v-model="pingguform.marketShare">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListMarketShare" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.marketShareRule}}</el-lable>
            </el-form-item>
            <el-form-item label="竞争情况:">
              <el-radio-group v-model="pingguform.competitionSituation">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListCompetitionSituation" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.competitionSituationRule}}</el-lable>
            </el-form-item>
            <el-form-item label="政策适应性:">
              <el-radio-group v-model="pingguform.policyAdaptability">
                <el-radio v-for="(item, index) in patentEstimateTypeVO.patentEstimateTypeListPolicyAdaptability" :key="index"
                :label="item.score" @change="compute">{{item.name}}</el-radio>
              </el-radio-group>
              <el-lable>x {{patentEstimateTypeVO.policyAdaptabilityRule}}</el-lable>
            </el-form-item>
            <el-form-item label="经济价值度">
              <el-input v-model="pingguform.evd" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="backsecond">上一页</el-button>
              <el-button type="primary" @click="nextthird">下一页</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :disabled="true" style="color:black"  label="专利价值度" name="fourth">
          <el-form>
            专利价值度=法律价值度LVD×法律价值度权重+技术价值度TVD×技术价值度权重+经济价制度EVD×经济价值度权重
            <el-form-item label="经济价值度">
              <el-input v-model="pingguform.lvd2" :disabled="true"></el-input> 
              <el-lable>x {{patentEstimateTypeVO.lvdRule}}</el-lable>
            </el-form-item>
            <el-form-item label="经济价值度">
              <el-input v-model="pingguform.tvd2" :disabled="true"></el-input>
              <el-lable>x {{patentEstimateTypeVO.tvdRule}}</el-lable>
            </el-form-item>
            <el-form-item label="经济价值度">
              <el-input v-model="pingguform.evd2" :disabled="true"></el-input>
              <el-lable>x {{patentEstimateTypeVO.evdRule}}</el-lable>
            </el-form-item>
            <el-form-item label="专利价值度">
              <el-input v-model="pingguform.pvd" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="backthird">上一页</el-button>
              <el-button type="primary" @click="computeSubmit">提交</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </a-modal>
    <a-modal :title="pinggulisttitle" :visible="pinggulistvisible" :confirm-loading="confirmLoading" :maskClosable="false"
      footer={[]}  @cancel="pinggulistCancel" width="800px">
       <el-table
          :data="pinggutableData"
          border
          style="width: 100%">
          <el-table-column
            prop="lvd"
            label="专利法律价值度"
            width="150">
          </el-table-column>
          <el-table-column
            prop="tvd"
            label="技术价值度"
            width="150">
          </el-table-column>
          <el-table-column
            prop="evd"
            label="经济价值度">
          </el-table-column>
          <el-table-column
            prop="pvd"
            label="专利价值度">
          </el-table-column>
          <el-table-column
            prop="createName"
            label="评估人">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="评估时间">
          </el-table-column>
        </el-table>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: "专利名称",
    dataIndex: "patentName",
    key: "patentName",
    //width:300,
    //ellipsis: true,
    fixed: "left",
  },
  {
    title: "专利号",
    dataIndex: "patentNo",
    key: "patentNo",
    width: 120,
    ellipsis: true,
  },
  {
    title: "专利类型",
    dataIndex: "patentType",
    key: "patentType",
    width: 130,
    ellipsis: true,
    scopedSlots: { customRender: "patentType" },
  },
  {
    title: "授权公告号",
    dataIndex: "authAnnouncementNo",
    key: "authAnnouncementNo",
    width: 110,
    ellipsis: true,
  },
  {
    title: "专利有效期",
    dataIndex: "termOfValidity",
    key: "termOfValidity",
    width: 110,
    ellipsis: true,
    scopedSlots: { customRender: "termOfValidity" },
  },
  {
    title: "年费有效期",
    dataIndex: "validityStatus",
    key: "validityStatus",
    width: 110,
    ellipsis: true,
    scopedSlots: { customRender: "validityStatus" },
  },
  {
    title: "专利权人",
    dataIndex: "patentee",
    key: "patentee",
    width: 110,
    ellipsis: true,
  },
  {
    title: "代理机构",
    dataIndex: "agencyzId",
    key: "agencyzId",
    width: 120,
    ellipsis: true,
  },
  {
    title: "状态",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
    width: 180,
    ellipsis: true,
  },
  {
    title: "修改人",
    dataIndex: "updateUserName",
    key: "updateUserName",
    width: 110,
    ellipsis: true,
  },
  {
    title: "修改时间",
    dataIndex: "updateTime",
    key: "updateTime",
    width: 110,
    ellipsis: true,
  },

  {
    title: "操作",
    dataIndex: "operation",
    key: "id",
    scopedSlots: { customRender: "operation" },
    width: 365,
    ellipsis: true,
    //fixed: "right",
  },
];
import request from "../util/request";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
export default {
  name: "user-center-towingpipe",
  data() {
    return {
      tuotitle: "专利评估",
      activeName: "first",
      iszhuang: false,
      locale,
      data: [],
      pinggutableData:[{
          lvd: '89',
          tvd: '98',
          evd: '56',
          pvd: '56',
          createName: '王小虎',
        }, {
          lvd: '89',
          tvd: '98',
          evd: '56',
          pvd: '56',
          createName: '王小虎',
        }, {
          lvd: '89',
          tvd: '98',
          evd: '56',
          pvd: '56',
          createName: '王小虎',
        }, {
          lvd: '89',
          tvd: '98',
          evd: '56',
          pvd: '56',
          createName: '王小虎',
        }],
      columns,
      types: [],
      org: [],
      page: {
        page: 1,
        pageSize: 999,
      },
      title: "",
      bindingtitle: "",
      tuoguantitle: "",
      pinggutitle: "专利评估",
      pinggulisttitle: "评估记录",
      patentTowingpipes: [],
      inputVisible: false,
      inputValue: "",
      visible: false,
      bindingvisible: false,
      tuoguanvisible: false,
      pingguvisible: false,
      pinggulistvisible: false,
      confirmLoading: false,
      isEdit: false,
      isEditStatus: false,
      isEditFlag: false,
      parents: [],
      form: {
        towingpipeLabel: [],
      },
      bindingform: {},
      tuoguanform: {},
      pingguform: {
        stability:"10",
        nonAvoidability:"10",
        indolence:"10",
        determinabilityInfringement:"10",
        periodValidity:"10",
        multinationalApplication:"10",
        patentLicensing:"10",
        lvd:0,
        progressiveness:"10",
        industryRends:"10",
        scopeUse:"10",
        supportingTechnologies:"10",
        substitutability:"10",
        maturity:"10",
        tvd:0,
        marketSituation:"10",
        marketProspects:"10",
        marketShare:"10",
        competitionSituation:"10",
        policyAdaptability:"10",
        evd:0,
        lvd2:0,
        tvd2:0,
        evd2:0,
      },
      queryForm: {
        page: 1,
        pageSize: 999,
      },
      patentEstimateTypeVO: {},
      status: [
        { key: 0, value: "待处理" },
        { key: 1, value: "托管中" },
        { key: 2, value: "待续费" },
        { key: 3, value: "拒绝" },
        { key: 4, value: "已超期  " },
        { key: 5, value: "终止托管" },
      ],
      userInfo: {},
    };
  },
  mounted() {
    const userInfo = localStorage.getItem("userInfo");

    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
      console.log(this.userInfo.type);
      if (this.userInfo.type == "代理机构") {
        this.iszhuang = true;
      }
      console.log(this.userInfo.menuVOS);
    }
    this.queryList();
    this.queryDict();
    this.queryDict1();
    this.queryDictTowingpipes();
    // this.queryOrg();
  },
  methods: {
    handestatus(record) {
      const params = { id: record.id, status: "" };
      if (record.status == 0) {
        params.status = 1;
      }
      if (record.status == 1) {
        params.status = 2;
      }
      if (record.status == 2) {
        params.status = 3;
      }

      request({
        url: "/api/center/order/patenttowingpipe/",
        method: "put",
        params,
      }).then((res) => {
        if (res.code == "200") {
          this.$message.info("操作成功");
          this.visible = false;
          this.form = {};
          this.queryList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    compute(){
         //法律价值度
      var stability=this.pingguform.stability;
      var stabilityRule = this.patentEstimateTypeVO.stabilityRule;
      var nonAvoidability=this.pingguform.nonAvoidability;
      var nonAvoidabilityRule = this.patentEstimateTypeVO.nonAvoidabilityRule;
      var indolence=this.pingguform.indolence;
      var indolenceRule = this.patentEstimateTypeVO.indolenceRule;
      var determinabilityInfringement=this.pingguform.determinabilityInfringement;
      var determinabilityInfringementRule = this.patentEstimateTypeVO.determinabilityInfringementRule;
      var periodValidity=this.pingguform.periodValidity;
      var periodValidityRule = this.patentEstimateTypeVO.periodValidityRule;
      var multinationalApplication=this.pingguform.multinationalApplication;
      var multinationalApplicationRule = this.patentEstimateTypeVO.multinationalApplicationRule;
      var patentLicensing=this.pingguform.patentLicensing;
      var patentLicensingRule = this.patentEstimateTypeVO.patentLicensingRule;
      //var lvd=this.pingguform.lvd;
      var lvdRule = this.patentEstimateTypeVO.lvdRule;
      //稳定性分值×稳定性权重
      var stabilityValue = parseFloat(stability)*parseFloat(stabilityRule);
      //不可规避性分值×不可规避性权重
      var nonAvoidabilityValue = parseFloat(nonAvoidability)*parseFloat(nonAvoidabilityRule);
      //依赖性分值×依赖性权重
      var indolenceValue = parseFloat(indolence)*parseFloat(indolenceRule);
      //专利侵权可判定性分值×专利侵权可判定性权重
      var determinabilityInfringementValue = parseFloat(determinabilityInfringement)*parseFloat(determinabilityInfringementRule);
      //有效期分值×有效期权重
      var periodValidityValue = parseFloat(periodValidity)*parseFloat(periodValidityRule);
      //多国申请分值×多国申请权重
      var multinationalApplicationValue = parseFloat(multinationalApplication)*parseFloat(multinationalApplicationRule);
      //专利许可状况分值×专利许可状况权重
      var patentLicensingValue = parseFloat(patentLicensing)*parseFloat(patentLicensingRule);
      //法律价值度（LVD）=稳定性分值×稳定性权重×（不可规避性分值×不可规避性权重+依赖性分值×依赖性权重+专利侵权可判定性分值×专利侵权可判定性权重+有效期分值×有效期权重+多国申请分值×多国申请权重+专利许可状况分值×专利许可状况权重）
      var lvdValue = parseFloat(stabilityValue)*(parseFloat(nonAvoidabilityValue)+parseFloat(indolenceValue)+parseFloat(determinabilityInfringementValue)+parseFloat(periodValidityValue)+parseFloat(multinationalApplicationValue)+parseFloat(patentLicensingValue));
      //lvdValue = lvdValue*10;
      this.pingguform.lvd=lvdValue.toFixed(2);
      this.pingguform.lvd2=lvdValue.toFixed(2);
       //技术价值度
      var progressiveness=this.pingguform.progressiveness;
      var progressivenessRule = this.patentEstimateTypeVO.progressivenessRule;
      var industryRends=this.pingguform.industryRends;
      var industryRendsRule = this.patentEstimateTypeVO.industryRendsRule;
      var scopeUse=this.pingguform.scopeUse;
      var scopeUseRule = this.patentEstimateTypeVO.scopeUseRule;
      var supportingTechnologies=this.pingguform.supportingTechnologies;
      var supportingTechnologiesRule = this.patentEstimateTypeVO.supportingTechnologiesRule;
      var substitutability=this.pingguform.substitutability;
      var substitutabilityRule = this.patentEstimateTypeVO.substitutabilityRule;
      var maturity=this.pingguform.maturity;
      var maturityRule = this.patentEstimateTypeVO.maturityRule;
      //var lvd=this.pingguform.lvd;
      var tvdRule = this.patentEstimateTypeVO.tvdRule;
      //先进性分值×先进性权重
      var progressivenessValue = parseFloat(progressiveness)*parseFloat(progressivenessRule);
      //行业发展趋势分值×行业发展趋势权重
      var industryRendsValue = parseFloat(industryRends)*parseFloat(industryRendsRule);
      //适用范围分值×适用范围权重
      var scopeUseValue = parseFloat(scopeUse)*parseFloat(scopeUseRule);
      //配套技术依存度分值×配套技术依存度权重
      var supportingTechnologiesValue = parseFloat(supportingTechnologies)*parseFloat(supportingTechnologiesRule);
      //可替代性分值×可替代性权重
      var substitutabilityValue = parseFloat(substitutability)*parseFloat(substitutabilityRule);
      //成熟度分值×成熟度权重
      var maturityValue = parseFloat(maturity)*parseFloat(maturityRule);
      //技术价值度（TVD）=（先进性分值×先进性权重+行业发展趋势分值×行业发展趋势权重+适用范围分值×适用范围权重+配套技术依存度分值×配套技术依存度权重+可替代性分值×可替代性权重+成熟度分值×成熟度权重）×10
      var tvdValue = parseFloat(progressivenessValue)+parseFloat(industryRendsValue)+parseFloat(scopeUseValue)+parseFloat(supportingTechnologiesValue)+parseFloat(substitutabilityValue)+parseFloat(maturityValue);
      tvdValue= tvdValue*10;
      this.pingguform.tvd=tvdValue.toFixed(2);
      this.pingguform.tvd2=tvdValue.toFixed(2);

        //技术价值度
      var marketSituation=this.pingguform.marketSituation;
      var marketSituationRule = this.patentEstimateTypeVO.marketSituationRule;
      var marketProspects=this.pingguform.marketProspects;
      var marketProspectsRule = this.patentEstimateTypeVO.marketProspectsRule;
      var marketShare=this.pingguform.marketShare;
      var marketShareRule = this.patentEstimateTypeVO.marketShareRule;
      var competitionSituation=this.pingguform.competitionSituation;
      var competitionSituationRule = this.patentEstimateTypeVO.competitionSituationRule;
      var policyAdaptability=this.pingguform.policyAdaptability;
      var policyAdaptabilityRule = this.patentEstimateTypeVO.policyAdaptabilityRule;
      //var evd=this.pingguform.evd;
      var evdRule = this.patentEstimateTypeVO.evdRule;
      //市场应用情况分值×市场应用情况权重
      var marketSituationValue = parseFloat(marketSituation)*parseFloat(marketSituationRule);
      //市场规模前景分值×市场规模前景权重
      var marketProspectsValue = parseFloat(marketProspects)*parseFloat(marketProspectsRule);
      //市场占有率权重+竞争情况分值
      var marketShareValue = parseFloat(marketShare)*parseFloat(marketShareRule);
      //竞争情况分值×竞争情况权重
      var competitionSituationValue = parseFloat(competitionSituation)*parseFloat(competitionSituationRule);
      //政策适应性分值×政策适应性权重
      var policyAdaptabilityValue = parseFloat(policyAdaptability)*parseFloat(policyAdaptabilityRule);
      //经济价值度（EVD）=（市场应用情况分值×市场应用情况权重+市场规模前景分值×市场规模前景权重+市场占有率分值×市场占有率权重+竞争情况分值×竞争情况权重+政策适应性分值×政策适应性权重）×10
      var evdValue = parseFloat(marketSituationValue)+parseFloat(marketProspectsValue)+parseFloat(marketShareValue)+parseFloat(competitionSituationValue)+parseFloat(policyAdaptabilityValue);
      evdValue=evdValue*10;
      this.pingguform.evd=evdValue.toFixed(2);
      this.pingguform.evd2=evdValue.toFixed(2);
      var lvd2 = this.pingguform.lvd2;
      var tvd2 = this.pingguform.tvd2;
      var evd2 =this.pingguform.evd2;
      //法律价值度LVD×法律价值度权重
      var lvd2Value = parseFloat(lvd2)*parseFloat(lvdRule);
      //技术价值度TVD×技术价值度权重
      var tvd2Value = parseFloat(tvd2)*parseFloat(tvdRule);
      //经济价制度EVD×经济价值度权重
      var evd2Value = parseFloat(evd2)*parseFloat(evdRule);
      //专利价值度=法律价值度LVD×法律价值度权重+技术价值度TVD×技术价值度权重+经济价制度EVD×经济价值度权重
      var pvdValue = parseFloat(lvd2Value)+parseFloat(tvd2Value)+parseFloat(evd2Value);
      this.pingguform.pvd=pvdValue.toFixed(2);
     
      console.log("-----------------------------------------------------");
    },
    nextfirst(){
      this.activeName="second";
      this.compute();
    },
    backfirst(){
      this.activeName="first";
      this.compute();
    },
    nextsecond(){
      this.activeName="third";
      this.compute();
    },
    backsecond(){
      this.activeName="second";
      this.compute();
    },
    nextthird(){
      this.activeName="fourth";
      this.compute();
    },
    backthird(){
      this.activeName="third";
      this.compute();
    },
    computeSubmit(){
      request({
          url: "/api/center/order/patenttowingpipe/estimate",
          method: "post",
          params: this.pingguform,
        }).then((res) => {
          if (res.code == "200") {
            this.$message.info("评估成功");
            this.pingguvisible = false;
            this.pingguform = {};
            this.pingguform.stability="10",
            this.pingguform.nonAvoidability="10",
            this.pingguform.indolence="10",
            this.pingguform.determinabilityInfringement="10",
            this.pingguform.periodValidity="10",
            this.pingguform.multinationalApplication="10",
            this.pingguform.patentLicensing="10",
            this.pingguform.lvd=0,
            this.pingguform.progressiveness="10",
            this.pingguform.industryRends="10",
            this.pingguform.scopeUse="10",
            this.pingguform.supportingTechnologies="10",
            this.pingguform.substitutability="10",
            this.pingguform.maturity="10",
            this.pingguform.tvd=0,
            this.pingguform.marketSituation="10",
            this.pingguform.marketProspects="10",
            this.pingguform.marketShare="10",
            this.pingguform.competitionSituation="10",
            this.pingguform.policyAdaptability="10",
            this.pingguform.evd=0,
            this.pingguform.lvd2=0,
            this.pingguform.tvd2=0,
            this.pingguform.evd2=0,
            this.activeName="first";
            this.queryList();
          } else {
            this.$message.warning(res.msg);
          }
        });
    },
    handleDetail(record) {
      request({
        url: `/api/center/order/patenttowingpipe/${record.id}`,
      }).then((res) => {
        this.visible = true;
        this.title = "详情";
        this.isEdit = false;
        this.isEditStatus = false;
        this.form = res.data;
        this.form.towingpipeLabel = this.form.towingpipeLabel.split(",");
      });
    },
    handleClose(removedTag) {
      let tags = this.form.towingpipeLabel;
      tags = tags.filter((tag) => tag !== removedTag);
      this.form.towingpipeLabel = tags;
    },
    onDelete(record) {
      request({
        url: "/api/center/order/patenttowingpipe/" + record.id,
        method: "delete",
      }).then((res) => {
        this.$message.info(res.msg);
        this.queryList();
      });
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.input.focus();
      });
    },
    handleEdit(record) {
      this.visible = true;
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(record));
      delete this.form.children;
      this.isEdit = true;
      this.isEditStatus = false;
      this.form.towingpipeLabel = this.form.towingpipeLabel.split(",");
      console.log(this.form.towingpipeLabel);
    },
    handleBinding(record) {
      this.bindingvisible = true;
      this.bindingtitle = "绑定";
      this.bindingform = record;
      this.bindingform.towingpipeId = record.id;
    },
    handleEditStatus(record) {
      this.visible = true;
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(record));
      delete this.form.children;
      this.isEdit = false;
      this.isEditStatus = true;
      this.form.towingpipeLabel = this.form.towingpipeLabel.split(",");
      console.log(this.form.towingpipeLabel);
    },
    handleInputChange(e) {
      this.inputValue = e.target.value;
    },

    handleInputConfirm() {
      const inputValue = this.inputValue;
      let tags = this.form.towingpipeLabel;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags);
      this.$set(this.form, "towingpipeLabel", tags);
      Object.assign(this, {
        inputVisible: false,
        inputValue: "",
      });
    },
    handleTuoguan(record) {
      this.tuoguanvisible = true;
      this.tuoguantitle = "续期";
      this.tuoguanform = record;
      this.tuoguanform.towingpipeId = record.id;
    },
    handlePinggu(record) {
      request({
        url: "/api/center/order/patenttowingpipe/estimate/" + record.id,
        method: "get",
      }).then((res) => {
        console.log(res)
        if (res.code == "200") {
          this.patentEstimateTypeVO = res.data;
          console.log("+++++++++++++++++++++++++++++++++++++++++++");
          console.log(this.patentEstimateTypeVO)
          console.log("--------------------------------------------------")
          this.pingguvisible = true;
          this.pinggutitle = "专利评估";
          this.pingguform.towingpipeId = record.id;
        } else {
          this.$message.warning(res.msg);
        }
      });
      //this.pingguform.towingpipeId = record.id;
    },
    handlePinggulist(record) {
     
      console.log(record.id)
      request({
        url: "/api/center/order/patenttowingpipe/estimatelist/" + record.id,
        method: "get",
      }).then((res) => {
        console.log(res)
        if (res.code == "200") {
          this.pinggutableData = res.data;
          this.pinggulistvisible = true;
          this.pinggulisttitle = "专利评估列表";
        } else {
          this.$message.warning(res.msg);
        }
      });
      //this.pingguform.towingpipeId = record.id;
    },

    handleAdd() {
      this.isEdit = true;
      this.isEditStatus = false;
      this.title = "新增";
      this.visible = true;
      this.form = {};
    },
    handleOk() {
      const params = Object.assign({}, this.form);
      if (typeof params.towingpipeLabel == "object") {
        params.towingpipeLabel = params.towingpipeLabel.join(",");
      }
      if (this.isEditStatus == false && this.isEdit == true) {
        this.isEditFlag = true;
      }
      if (this.isEditStatus == true && this.isEdit == false) {
        this.isEditFlag = true;
      }
      if (this.isEditFlag) {
        request({
          url: "/api/center/order/patenttowingpipe",
          method: this.title == "修改" ? "put" : "post",
          params: params,
        }).then((res) => {
          if (res.code == "200") {
            this.$message.info("修改成功");
            this.visible = false;
            this.form = {};
            this.queryList();
          } else {
            this.$message.warning(res.msg);
          }
        });
      } else {
        this.visible = false;
        this.form = {};
      }
    },
    bindingOk() {
      request({
        url: "/api/center/order/patenttowingpipe/bindingUser",
        method: "post",
        params: this.bindingform,
      }).then((res) => {
        if (res.code == "200") {
          this.$message.info("绑定成功");
          this.bindingvisible = false;
          this.bindingform = {};
          this.queryList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    tuoguanOk() {
      request({
        url: "/api/center/order/patenttowingpipe/tuoguanUser",
        method: "post",
        params: this.tuoguanform,
      }).then((res) => {
        if (res.code == "200") {
          this.$message.info("绑定成功");
          this.tuoguanvisible = false;
          this.tuoguanform = {};
          this.queryList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    pingguOk() {
      request({
        url: "/api/center/order/patenttowingpipe/tuoguanUser",
        method: "post",
        params: this.tuoguanform,
      }).then((res) => {
        if (res.code == "200") {
          this.$message.info("绑定成功");
          this.tuoguanvisible = false;
          this.tuoguanform = {};
          this.queryList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    fmtTypes(text) {
      const result = this.types.find((ele) => ele.key == text);
      return result ? result.value : "";
    },
    fmtStatus(text) {
      console.log("2222" + text);
      console.log(this.status);
      const result = this.status.find((ele) => ele.key == text);

      console.log(result);
      return result ? result.value : "";
    },
    fmtValidity(obj) {
      if (obj.validityStatus == 1) {
        return (
          "<span style='color:red'>有效期不足" +
          obj.termOfValidityStr +
          "天</span>"
        );
      } else {
        return obj.towingpipeDate;
      }
    },
    fmtAgency(text) {
      const result = this.org.find((ele) => ele.key == text);
      return result ? result.value : "";
    },
    queryDict() {
      request({
        url: "/api/client/common/select/dict/list",
        params: {
          key: "patentType",
        },
      }).then((res) => {
        if (res.code == "200") {
          this.types = res.data;
        }
      });
    },
    queryDictTowingpipes() {
      request({
        url: "/api/client/common/select/dict/list",
        params: {
          key: "towingpipe_status",
        },
      }).then((res) => {
        if (res.code == "200") {
          this.patentTowingpipes = res.data;
        }
      });
    },
    queryDict1() {
      request({
        url: "/api/client/common/select/dict/list",
        params: {
          key: "towingpipe_status",
        },
      }).then((res) => {
        if (res.code == "200") {
          this.status = res.data;
        }
      });
    },
    queryOrg() {
      request({
        url: "/api/client/common/select/enterprise/list?key=ORG_OWNER",
      }).then((res) => {
        this.org = res.data;
      });
    },
    searchList() {
      this.queryList();
    },
    exportExcel() {
      request({
        url: "/api/center/order/patenttowingpipe/export",
        method: "get",
        params: this.queryForm,
      }).then((res) => {
        if (res.code == "200") {
          let a = document.createElement("a");
          a.href = res.data;
          a.click();
        }
      });
    },
    queryList() {
      request({
        url: "/api/center/order/patenttowingpipe/list",
        method: "get",
        params: this.queryForm,
      }).then((res) => {
        if (res.code == "200") {
          this.data = res.data.records;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.form = false;
    },
    bindingCancel() {
      this.bindingvisible = false;
      this.bindingform = false;
    },
    tuoguanCancel() {
      this.tuoguanvisible = false;
      this.tuoguanform = false;
    },
    pingguCancel() {
      this.pingguvisible = false;
      this.pingguform = false;
    },
    pinggulistCancel() {
      this.pinggulistvisible = false;
      this.pinggulistform = false;
    },
  },
};
</script>

<style lang="less">
.ant-table-body {
  overflow: hidden;
}

::v-deep .el-tabs__item.is-disabled {
  color: #9d9b9e;
  font-size: 13px;
  font-weight: bold;
  cursor: default;
}
</style>
